export const SECRET_TOKEN = 'ddee18ef6a6804fbb919b25f790005e3'